export default __webpack_public_path__ + "static/media/orchestraCover.ee8458aa.jpg";